export { DeleteLeadComponent } from './delete-lead/delete-lead.component';
export { LeadDetailModalComponent } from './lead-detail-modal/lead-detail-modal.component';
